module.exports = __webpack_public_path__ + "img/logo.e9a9e4c8.png";